var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var arrowTop = {
    borderWidth: "".concat(8, "px ").concat(8, "px 0 ").concat(8, "px"),
    borderLeftColor: 'transparent',
    borderRightColor: 'transparent',
    borderBottomColor: 'transparent',
    bottom: 8 * -1,
    marginTop: 0,
    marginBottom: 0,
};
export var arrowBottom = {
    borderWidth: "0 ".concat(8, "px ").concat(8, "px ").concat(8, "px"),
    borderLeftColor: 'transparent',
    borderRightColor: 'transparent',
    borderTopColor: 'transparent',
    top: 8 * -1,
    marginTop: 0,
    marginBottom: 0,
};
export var arrowLeft = {
    borderWidth: "".concat(8, "px 0 ").concat(8, "px ").concat(8, "px"),
    borderTopColor: 'transparent',
    borderRightColor: 'transparent',
    borderBottomColor: 'transparent',
    right: 8 * -1,
    marginLeft: 0,
    marginRight: 0,
};
export var arrowRight = {
    borderWidth: "".concat(8, "px ").concat(8, "px ").concat(8, "px 0"),
    borderLeftColor: 'transparent',
    borderTopColor: 'transparent',
    borderBottomColor: 'transparent',
    left: 8 * -1,
    marginLeft: 0,
    marginRight: 0,
};
export var arrow = {
    alignContent: 'center',
    margin: 8,
    display: 'block',
    width: 0,
    height: 0,
    borderStyle: 'solid',
    position: 'absolute',
    color: 'transparent',
    borderColor: '#4B5863',
};
export var toolTipHover = {
    opacity: 1,
    pointerEvents: 'all',
    transitionDelay: '50ms',
};
export var toolTipNoHover = {
    opacity: 0,
    pointerEvents: 'none',
    transitionDelay: '500ms',
};
export var noTransition = {
    transitionDelay: '0ms',
    transitionDuration: '0ms',
};
export var toolTip = __assign(__assign({}, toolTipNoHover), { backgroundColor: '#42505C', boxShadow: '0 2px 4px rgba(166,176,186,.4)', borderRadius: 8, color: '#ffffff', display: 'block', fontSize: 12, fontWeight: '600', lineHeight: '18px', maxWidth: 280, minWidth: 40, padding: '11px 16px', position: 'absolute', transition: "opacity 300 cubic-bezier(0.645, 0.045, 0.355, 1.000)", whiteSpace: 'normal', zIndex: 700, '&[data-tooltip-placement*="bottom"]': {
        '[data-arrow="true"]': __assign({}, arrowBottom),
    }, '&[data-tooltip-placement*="top"]': {
        '[data-arrow="true"]': __assign({}, arrowTop),
    }, '&[data-tooltip-placement*="left"]': {
        '[data-arrow="true"]': __assign({}, arrowLeft),
    }, '&[data-tooltip-placement*="right"]': {
        '[data-arrow="true"]': __assign({}, arrowRight),
    } });
